import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IThemeDirectiveProvider } from '@nimbus-library/features/modal/i-theme-directive.provider';
import { ChartTheme } from '@nimbus-library/features/charts/models/char-theme.enum';
import { CommonThemeState } from '@nimbus-library/features/shared/store/theme-store/common-theme.state';
import { IMap } from '@nimbus-library/features/shared/models/interfaces';

@Injectable({ providedIn: 'root' })
export class ThemeResolver implements IThemeDirectiveProvider {
  private themeMapper: IMap<number> = {
    [ChartTheme.Light]: 0,
    [ChartTheme.Dark]: 1,
    [ChartTheme.HighContrast]: 2,
  };

  public constructor(private readonly store: Store) {}

  public getTheme(): Observable<number> {
    return this.store.select(CommonThemeState.theme).pipe(map((theme) => this.themeMapper[theme]));
  }
}
